<template>
  <div>
    <stepheader :step="step" />
    <div v-if="indirizzo">

      <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false"
        style="">

        <div class="row">
          <div class="col-12">

            <h3>{{ indirizzo.denominazione }}</h3>
            <span v-if="indirizzo.citofono && indirizzo.citofono != ''">Citofono: {{ indirizzo.citofono }}<br /></span>
            {{ indirizzo.indirizzo }} {{ indirizzo.comune }} {{ indirizzo.provincia }} {{ indirizzo.cap }}<br />
            <span v-if="indirizzo.telefono && indirizzo.telefono != ''">Telefono: {{ indirizzo.telefono }}<br /></span>
            <span v-if="indirizzo.cellulare && indirizzo.cellulare != ''">Cellulare: {{ indirizzo.cellulare }}<br /></span>
            <span v-if="indirizzo.email && indirizzo.email != ''">Email: {{ indirizzo.email }}<br /></span>
            Confermi che i dati sono corretti?
          </div>

        </div>
      </div>
    </div>
    <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>




  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "indirizzoinfo",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     indirizzo:null
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
    this.indirizzo = this.ticket.logistica.filter(x=>x.tipologia==this.step.categorytype)[0];
    if(!this.indirizzo || !this.isValidData()){ //!this.indirizzo || Object.values(this.indirizzo).some(value => !value) //!this.indirizzo || this.indirizzo.indirizzo == ""
      var nextstep = this.step.categorytype == "ritiro" ? "indirizzoritiroedit" : "indirizzoconsegnaedit";
      this.fireaction("wrong", nextstep);
    }
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
        default:
           this.$emit("goto",nextstep)
          break;

      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    },
    isValidData: function(){
      if (
            this.indirizzo.indirizzo == "" ||
            this.indirizzo.comune == "" ||
            this.indirizzo.provincia == "" ||
            this.indirizzo.cap == "" ||
            this.indirizzo.denominazione == "" ||
            (this.indirizzo.telefono == "" && this.indirizzo.cellulare == "")         
          ) 
          return false;
      return true;
    }
  },
};
</script>